// lib/api/aha.ts — aha_forge v1 endpoint wrappers.
//
// Spec: docs/contracts/aha/openapi.aha.v1.yaml (3 new endpoints + extended /me).
// Idempotency-Key generated client-side per ADDENDUM correction 7.
import { get, post } from '@/api/client';
import type {
  AggregatedStatsResponse,
  PersonalizationConsentRequest,
  PersonalizationConsentResponse,
  PersonalizationConsentWithdrawResponse,
} from '@/types/api';

export const CURRENT_CONSENT_TEXT_VERSION = '2026-05-07-v1';

function freshIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // best-effort fallback for older runtimes (e.g. RN webviews)
  return `idempo-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function acceptPersonalizationConsent(
  body?: Partial<PersonalizationConsentRequest>,
): Promise<PersonalizationConsentResponse> {
  const payload: PersonalizationConsentRequest = {
    accept: body?.accept ?? true,
    consent_text_version: body?.consent_text_version ?? CURRENT_CONSENT_TEXT_VERSION,
  };
  return post<PersonalizationConsentResponse>('/me/personalization-consent', payload, {
    headers: { 'Idempotency-Key': freshIdempotencyKey() },
  });
}

export async function declinePersonalizationConsent(): Promise<PersonalizationConsentResponse> {
  return acceptPersonalizationConsent({ accept: false });
}

export async function withdrawPersonalizationConsent(
  reason?: string,
): Promise<PersonalizationConsentWithdrawResponse> {
  return post<PersonalizationConsentWithdrawResponse>(
    '/me/personalization-consent/withdraw',
    reason ? { reason } : {},
    {
      headers: { 'Idempotency-Key': freshIdempotencyKey() },
    },
  );
}

export async function getAggregatedStats(
  windowDays = 30,
): Promise<AggregatedStatsResponse> {
  return get<AggregatedStatsResponse>(`/me/aggregated-stats?window_days=${windowDays}`);
}
